import { ComponentPropsWithoutRef } from 'react';

export const StructureIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 22 18" fill="none">
      <path
        d="M13 4c0-2.482.518-3 3-3h2c2.482 0 3 .518 3 3s-.518 3-3 3h-2c-2.482 0-3-.518-3-3Zm0 0-3 5 3 5m0 0c0-2.482.518-3 3-3h2c2.482 0 3 .518 3 3s-.518 3-3 3h-2c-2.482 0-3-.518-3-3ZM1 9c0-2.482.518-3 3-3h2c2.482 0 3 .518 3 3s-.518 3-3 3H4c-2.482 0-3-.518-3-3Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
